import { FORM_ERROR } from "final-form";
import { t } from "../i18n";
const formError = (error) => {
  const fieldErrors = {};
  const validationErrors = error?.response?.data?.data;
  if (!validationErrors) {
    return { [FORM_ERROR]: t("There was an error. Please try again later.") };
  }
  Object.keys(validationErrors || {}).forEach((key) => {
    const lovercaseErrorKey = key.charAt(0).toLowerCase() + key.slice(1);
    fieldErrors[lovercaseErrorKey] = Array.isArray(validationErrors[key]) ? validationErrors[key].join(" ") : validationErrors[key];
  });
  return fieldErrors;
};
var formError_default = formError;
export {
  formError_default as default
};
